import React, { useEffect } from 'react'
import { lang } from 'utils/helpers'
import './styles.scss'

const Pagination = ({ pageCount, page, handlePageClick }) => {
  useEffect(() => {
    pageNumber()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageCount])

  const previousBtn = () => {
    if (pageCount <= 1) return null

    return (
      <button
        className='previousButton'
        onClick={() => handlePageClick('page', page - 1)}
      >
        {lang('dashboard_previous')}
      </button>
    )
  }

  const nextBtn = () => {
    if (pageCount <= 1) return null

    return (
      <button
        className='nextButton'
        onClick={() => handlePageClick('page', page + 1)}
      >
        {lang('dashboard_next')}
      </button>
    )
  }

  const pageNumber = () => {
    const pageNumberBtn = []
    for (let i=0; i < pageCount; i++) {
      if (pageCount > 25 && ((page >= 8 && i === 2) || (i === pageCount - 3 && page <= pageCount - 14))) {
        pageNumberBtn.push(<span key={`page_${i}`}>...</span>)
      } else if (pageCount > 25 && ((i < page - 10 && page > 5 && ![0, 1].includes(i)) || (i > page + 10 && i !== pageCount - 1 && i !== pageCount - 2))) {
        pageNumberBtn.push(null)
      } else {
        pageNumberBtn.push(
          <button
            key={`page_${i}`}
            className={`numberButton ${page === i ? 'numberPageSelect' : ''}`}
            onClick={() => handlePageClick('page', i)}
          >
            {i + 1}
          </button>
        )
      }
    }

    return pageNumberBtn
  }

  return (
    <div className='navigationButtons'>
      {previousBtn()}
      <div className='navigationButtons__page-numbers-container'>
        {pageNumber()}
      </div>
      {nextBtn()}
    </div>
  )
}

export default Pagination
